import React from "react";
import "./Button.css";

const Button = ({ className, children, onClick, href }) => {
  if (href) {
    return (
      <a
        className={`${className}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  } else {
    return (
      <button className={`${className}`} onClick={onClick}>
        {children}
      </button>
    );
  }
};

export default Button;
